import React from 'react';
import { SC_IMAGES } from '../../data/images';

const StatCard = ({ value, label, sub, countup }) => (
  <div className="stat-card reveal">
    <div className="stat-value counting" {...(countup ? { 'data-countup': true, 'data-count': value } : {})}>{value}</div>
    <div className="stat-label">{label}</div>
    <div className="stat-sub">{sub}</div>
  </div>
);

const Testimonial = ({ quote, name, meta, initials, photo }) => (
  <figure className="testimonial reveal">
    <blockquote>{quote}</blockquote>
    <figcaption className="testimonial-author">
      {photo ?
        <div className="av av-photo" style={{ backgroundImage: `url(${photo})` }} /> :
        <div className="av">{initials}</div>}
      <div>
        <div className="nm">{name}</div>
        <div className="meta">{meta}</div>
      </div>
    </figcaption>
  </figure>
);

const SocialProof = () => (
  <section id="proof" className="section-proof">
    <div className="container">
      <div className="section-head">
        <span className="eyebrow">Trusted by families like yours</span>
        <h2 className="section-title">
          Thousands of families have stopped leaving money on the table.
        </h2>
      </div>

      <div className="proof-stats">
        <StatCard value="12,400+" label="Families helped this year" sub="Across 5 states and growing" countup />
        <StatCard value="$3,240" label="Average monthly payment" sub="Based on 2025 approvals" countup />
        <StatCard value="94%" label="Application approval rate" sub="When eligibility is confirmed" countup />
      </div>

      <div className="testimonials">
        <Testimonial
          quote="I'd been caring for my mom after her stroke for two years. I had no idea I could be paid for it. SupportCare walked me through every form. I'm now getting $2,800 a month."
          name="Maria R." meta="Daughter caregiver · Sacramento, CA" initials="MR"
          photo={SC_IMAGES.a1} />

        <Testimonial
          quote="The paperwork felt impossible. My advocate Jennifer knew every program, called the agency for me, and never let a question go unanswered. Approved in 11 days."
          name="James T." meta="Son caregiver · Phoenix, AZ" initials="JT"
          photo={SC_IMAGES.a2} />

        <Testimonial
          quote="I was on the edge of quitting my job to care for my husband. Now I'm paid for the care I was already giving. It changed everything for our family."
          name="Angela L." meta="Spouse caregiver · Detroit, MI" initials="AL"
          photo={SC_IMAGES.a3} />
      </div>
    </div>
  </section>
);

export default SocialProof;
